import React, { useContext } from "react";

import { IntlContext } from "context";
import type { OurServiceInterface } from "types/service";
import { ProviderDetailCard } from "./ProviderDetailCard";

interface Props {
    provider: OurServiceInterface["provider"];
}

export const ProviderAboutCard: React.FC<Props> = ({ provider }) => {
    const intl = useContext(IntlContext);

    return (
        <ProviderDetailCard title={intl.formatMessage("provider.view.section_about")} titleSize="xl">
            <p className="whitespace-pre-line leading-relaxed text-muted-foreground">
                {provider.description || intl.formatMessage("provider.view.no_description")}
            </p>
        </ProviderDetailCard>
    );
};
